import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { useDecision } from '@optimizely/react-sdk';

import { documentTitlePrefixAtom } from '@frontend/atoms';

import { useUnreadCount } from './useUnreadCount';

export function useNotificationTitle() {
  const [decision] = useDecision('notifications');
  const enabled = decision.enabled;

  const { data: unreadCount } = useUnreadCount({ enabled });
  const setPrefix = useSetAtom(documentTitlePrefixAtom);

  useEffect(() => {
    const count = enabled ? (unreadCount ?? 0) : 0;
    setPrefix(count > 0 ? `(${count}) ` : '');

    return () => setPrefix('');
  }, [enabled, unreadCount, setPrefix]);
}
